export default "__VITE_ASSET__Yn3BWxe8__"